export const lavisAndCrab = {
  id: "lavisAndCrab",
  link: "/#/recipes/recipes/lavisAndCrab",
  name: "Boiled Lavis with Spiced Crab",
  cuisine: "Alethi",
  summary: "Coconut hominy chowder topped with crab leg meat",
  inspiration: "New England Clam Chowder",
  quantity: "4 servings",
  time: "90 minutes",
  notes:
    "I almost went completely literal on this one and just boiled some hominy and added crab meat on top. It seemed like there was an opportunity to make this a bit better than that, though, so I took some inspiration from New England clam chowder and turned it into a full soup. I used snow crab legs, though whatever type of crab you have access to should work fine.",
  quotes:
    "(She) handed him a bowl with some boiled lavis grain and spiced crab meat on top. (Wind and Truth ch 2)",
  image: "https://jozomby-public.s3.amazonaws.com/recipes/lavis-and-crab-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "crab",
          display:
            "8 oz crab meat (1.5 - 2 lbs snow crab leg clusters, or 1 lb king crab legs)"
        },
        {
          item: "gochugaru",
          display: "1 tbsp gochugaru"
        },
        {
          item: "salt",
          display: "1 1/4 tsp salt, divided"
        },
        {
          item: "coriander",
          display: "1/2 tsp ground coriander"
        },
        {
          item: "onion",
          display: "1 onion"
        },
        {
          item: "coconut",
          display: "1 tbsp coconut oil"
        },
        {
          item: "mirin",
          display: "1/4 cup mirin"
        },
        {
          item: "garlicClove",
          display: "2 cloves garlic"
        },
        {
          item: "seafoodStock",
          display: "2 cups seafood stock"
        },
        {
          item: "hominy",
          display: "1 25 oz can hominy"
        },
        {
          item: "mustard",
          display: "1/2 tsp ground mustard seed"
        },
        {
          item: "coconut",
          display: "1 14 oz can coconut milk"
        },
        {
          item: "corn",
          display: "1 tbsp corn starch"
        }
      ]
    }
  ],
  steps: [
    "If the crab legs are raw, steam them until cooked. The time will depend on your type of crab, and whether the legs are frozen or not, but it is generally 6 to 14 minutes. Shell the crab legs and remove the meat.",
    "Cut the crab meat to bite sized pieces and toss with the gochugaru, 1/4 tsp of the salt, and the coriander. Set aside.",
    "Peel and dice the onion. In a pot, melt the coconut oil over medium high heat. Add the onion and cook and stir until tender but not browned, about 5 minutes. Add the seafood stock. Drain the can of hominy and add the hominy to the pot. Also add the remaining 1 tsp salt and the ground mustard seed. Cover the pot, reduce heat to simmer, and simmer for 10 minutes.",
    "In a bowl, mix the coconut milk and corn starch. Once the pot is done simmering, add the coconut milk mixture to the pot and stir until combined. Increase the heat to medium high and bring to a boil.",
    "Remove the pot from the heat. To serve, ladle the soup into bowls and top with the prepared crab meat."
  ]
}
